import React, { Component, ReactNode } from 'react';
import { Modal, Box, Typography, IconButton, Divider } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  maxWidth?: string;
  padding?: string;
}

const webStyle = {
  modalStyle: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding:'30px',
    overflowY: 'auto',
    bgcolor: "#FFFFFF",
    boxShadow: 24,
    borderRadius: '20px',
    width:'700px',
    '@media (max-width: 950px)': {
      width: 'auto',
      minWidth: '300px',
      padding:'15px',
    }
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom:'20px'
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '24.38px',
    fontFamily: "Montserrat !important",
    "@media (max-width: 600px)": {
      fontSize: "16px"
    },
  },
  closeIcon: {
    p: 0.5,
    "& svg": {
      fill: "#000",
    },
  },
  customScrollbar: {
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "rgba(100, 100, 100, 0.7)",
    },
    "&:hover::-webkit-scrollbar-thumb:hover": {
      background: "rgba(100, 100, 100, 1)",
    },
  },
};

class CommonModal extends Component<Props> {
  render() {
    const { open, onClose, title, children } = this.props;

  return (
      <Modal open={open} onClose={onClose} disableRestoreFocus aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...webStyle.modalStyle,
            ...webStyle.customScrollbar,
            
          }}
        >
          {title && <Box sx={{ ...webStyle.modalTitleContainer }}>
            <Typography variant="h6" sx={{ ...webStyle.modalTitle }}>{title}</Typography>
            <IconButton onClick={onClose} sx={{ ...webStyle.closeIcon }}>
              <CloseRoundedIcon fontSize='small' />
            </IconButton>
          </Box>}
        <Divider />
        <Box>{children}</Box>
      </Box>
    </Modal>
  );
  }
}

export default CommonModal;